import { UAParser } from 'ua-parser-js';

const ONE_MINUTE = 60 * 1000;
const TWO_MINUTES = 2 * ONE_MINUTE;
const FIVE_MINUTES = 5 * ONE_MINUTE;

/**
 * Rounds input in milliseconds to 1s
 *
 * @param timeInMs - milliseconds to be rounded.
 * @returns rounded time in seconds.
 */
export function roundToSeconds(timeInMs: number) {
  const roundedMs = Math.round(timeInMs / 1000) * 1000;

  return roundedMs / 1000;
}

/**
 * Rounds input in milliseconds to 5s
 *
 * @param timeInMs - milliseconds to be rounded.
 * @returns rounded time in seconds.
 */
export function roundToFiveSeconds(timeInMs: number) {
  const roundedMs = Math.round(timeInMs / 5000) * 5000;

  return roundedMs / 1000;
}

export function timeElapsedFrom(start: number | null) {
  if (start === null) {
    return null;
  }

  return Date.now() - start;
}

export function formatElapsedTimeSinceInit(timeInMs: number) {
  if (timeInMs < ONE_MINUTE) {
    return roundToSeconds(timeInMs);
  }

  if (timeInMs <= TWO_MINUTES) {
    return roundToFiveSeconds(timeInMs);
  }

  return '>2m';
}

export function formatElapsedTimeSinceSuccess(timeInMs: number) {
  if (timeInMs <= FIVE_MINUTES) {
    return roundToFiveSeconds(timeInMs);
  }

  return '>5m';
}

export function parseUa(ua: string) {
  const parser = new UAParser(ua);

  return parser.getResult();
}
